import axios from 'axios'
import { axiosNonLoading, axiosSFS, params, axiosUploadFile } from '@/api/instance'
import * as AWS from 'aws-sdk'

const sendEmailConfirm = (data) => {
  const url = axiosSFS.defaults.baseURL + '/send-email-confirm'
  return axiosSFS({
    method: 'post',
    url: url,
    data: data
  }).then(function (response) {
    return response?.data
  })
}

const fetchServices = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/services?curPaxId=' + param
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchBus = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/bus'
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchListHotel = (param) => {
  const url = axiosSFS.defaults.baseURL + '/hotels/list'
  axiosSFS.defaults.error_link = '/no-hotels-available?secret=' + param.secret
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const bookHotel = (param) => {
  const url = axiosSFS.defaults.baseURL + '/hotels/book'
  if (param.hotel_list_page) {
    delete param.hotel_list_page
    return axiosNonLoading({
      method: 'post',
      url: url,
      data: {
        data: param
      }
    }).then(function (response) {
      return response?.data
    })
  }
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const getMatrixHotels = (param) => {
  const url = axiosSFS.defaults.baseURL + '/hotels/check-room-matrix'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const fetchRebook = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/rebook'
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchRentalCar = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/rental-car'
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchHotel = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/hotel'
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchVoucherHotel = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/voucher-hotel'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchTrain = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/train'
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const assignSer = (param) => {
  const url = axiosSFS.defaults.baseURL + '/services/assign'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const removeSer = (param) => {
  const url = axiosSFS.defaults.baseURL + '/services/remove'
  return axiosSFS({
    method: 'delete',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const fetchTaxiVoucher = () => {
  const url = axiosSFS.defaults.baseURL + '/taxi/getDetailVoucher/' + params.secret
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchTaxiCompanies = () => {
  const url = axiosSFS.defaults.baseURL + '/taxi/getTaxiCompanies/' + params.secret
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      let listTaxiCompanies = []
      _.forEach(res.data, function (item, key) {
        if (item.published == 1) {
          listTaxiCompanies.push(item)
        }
      })
      return listTaxiCompanies
    }
  })
}

const updateOptionTaxiTranfer = (param) => {
  const url = axiosSFS.defaults.baseURL + '/store-taxi-option/' + params.secret
  return axiosSFS({
    method: 'put',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const updateTaxiTransferOption = (param) => {
  const url = axiosSFS.defaults.baseURL + '/update-taxi-transfer-option/' + params.secret
  return axiosSFS({
    method: 'put',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const sendTaxiTransferSMSToOthers = (param) => {
  const url = axiosSFS.defaults.baseURL + '/send-sms-to-others/' + params.secret
  return axiosSFS({
    method: 'put',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const saveTaxiTransfer = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/issue'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const issueTaxiTransferVoucher = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/issue-taxi-transfer'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const saveMatrixTaxi = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/save-matrix-taxi'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const updatePaxMultiple = (param) => {
  const url = axiosSFS.defaults.baseURL + '/passengers/update-multiple/phone'
  return axiosSFS({
    method: 'put',
    url: url,
    data: param
  }).then(function (response) {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const storeFileRefreshment = (data) => {
  const url = axiosUploadFile.defaults.baseURL + '/refreshment/parse'
  return axiosUploadFile({
    method: 'post',
    url: url,
    data: data.formData
  }).then(function (response) {
    return response?.data
  })
}

const getInfoRefreshment = (refreshmentId) => {
  const url = `${axiosSFS.defaults.baseURL}/refreshment/${params.secret}/${refreshmentId}`
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getListMealPlanReceiptInfo = () => {
  const url = axiosSFS.defaults.baseURL + '/mealPlanReceipt/' + params.secret
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getMealPlanReceiptByVoucherCode = (voucher_code) => {
  const url = axiosSFS.defaults.baseURL + '/mealPlanReceipt/' + params.secret
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      voucher_code: voucher_code
    }
  }).then(function (response) {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getInfoTaxi = (data) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/' + params.secret + '?taxiDetailId=' + data.taxiDetailId
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getPricePersonRefreshment = (refreshmentId) => {
  const url = axiosSFS.defaults.baseURL + '/refreshment/price-per-person/' + params.secret + '?refreshmentId=' + refreshmentId
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getPricePersonTaxi = () => {
  const url = axiosSFS.defaults.baseURL + '/refreshment/price-per-person/' + params.secret
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const storeReceipt = (data) => {
  const url = axiosSFS.defaults.baseURL + '/refreshment/storeReceipt'
  const params = data.refreshmentId ? { refreshmentId: data.refreshmentId } : {}
  return axiosSFS({
    method: 'post',
    url: url,
    params,
    data: {
      data: data.data,
      secret: data.secret
    }
  }).then(function (response) {
    return response?.data
  })
}

const storeReceiptMealPlan = (data) => {
  const url = axiosSFS.defaults.baseURL + '/mealplan/storeReceipt?voucher_code=' + data.voucher_code
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: data.data,
      secret: data.secret
    }
  }).then(function (response) {
    return response?.data
  })
}

const karhooBookTaxi = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/karhoo/book'
  return axiosNonLoading({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const karhooGetDetail = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/karhoo/detail'
  return axiosNonLoading({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const karhooGetPassengerDetail = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/karhoo/detail-passenger'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const karhooCancel = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/karhoo/cancel'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const getCurrencies = (param) => {
  const url = axiosSFS.defaults.baseURL + '/transfer-wise/currencies'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getCountrys = () => {
  const url = axiosSFS.defaults.baseURL + '/country/list'
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const getDataBank = (param) => {
  const url = axiosSFS.defaults.baseURL + '/transfer-wise/account-requirement'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const getDataFields = (param) => {
  const url = axiosSFS.defaults.baseURL + '/transfer-wise/account-requirement-post'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const checkValidatorField = (url) => {
  return axios
    .get(url)
    .then((response) => {
      return response?.data
    })
    .catch((err) => {
      return err.response.data
    })
}

const saveInfoPaxMonetary = (data) => {
  const url = axiosSFS.defaults.baseURL + '/monetary/storeMonetary'
  return axiosSFS({
    method: 'post',
    url: url,
    data: data
  }).then(function (response) {
    return response?.data
  })
}

const getDataMoneTary = (monetaryId) => {
  const url = axiosSFS.defaults.baseURL + '/monetary/' + params.secret + '?monetaryId=' + monetaryId
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    return res?.success ? res.data : {}
  })
}

const openMonetaryOrder = (param) => {
  const url = axiosSFS.defaults.baseURL + '/monetary/update'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const confirmMonetaryCompensation = (param) => {
  const url = axiosSFS.defaults.baseURL + '/monetary/confirm'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const fetchStatusMonetary = (param) => {
  const url = axiosSFS.defaults.baseURL + '/monetary/status'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    return response?.data
  })
}

const saveAttemptsKarhoo = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/karhoo/attempt'
  return axiosSFS({
    method: 'post',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const sendEmailExceedPrice = (param) => {
  const url = axiosSFS.defaults.baseURL + '/taxi/' + params.secret + '/email-exceeds'
  return axiosSFS({
    method: 'put',
    url: url,
    data: param
  }).then(function (response) {
    return response?.data
  })
}

const getInfoMealPlan = (data) => {
  const url = axiosUploadFile.defaults.baseURL + '/getMealPlanReceipt'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      secret: data.secret,
      mealPlanReceiptId: data.mealPlanReceiptId
    }
  }).then(function (response) {
    return response?.data
  })
}

const getInfoMealPlanPayment = (voucher_code) => {
  const url = `${axiosSFS.defaults.baseURL}/mealplan/${params.secret}/${voucher_code}`
  return axiosSFS.get(url).then((response) => {
    const res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

export {
  fetchServices,
  fetchBus,
  fetchListHotel,
  bookHotel,
  fetchRebook,
  fetchRentalCar,
  fetchHotel,
  getCurrencies,
  getDataBank,
  getDataFields,
  getPricePersonRefreshment,
  fetchTrain,
  assignSer,
  removeSer,
  fetchVoucherHotel,
  fetchTaxiVoucher,
  fetchTaxiCompanies,
  updateOptionTaxiTranfer,
  updateTaxiTransferOption,
  sendTaxiTransferSMSToOthers,
  saveTaxiTransfer,
  issueTaxiTransferVoucher,
  saveMatrixTaxi,
  updatePaxMultiple,
  storeFileRefreshment,
  storeReceipt,
  storeReceiptMealPlan,
  getInfoRefreshment,
  getListMealPlanReceiptInfo,
  karhooBookTaxi,
  karhooGetDetail,
  karhooCancel,
  karhooGetPassengerDetail,
  checkValidatorField,
  saveInfoPaxMonetary,
  sendEmailConfirm,
  getDataMoneTary,
  openMonetaryOrder,
  confirmMonetaryCompensation,
  getPricePersonTaxi,
  getInfoTaxi,
  saveAttemptsKarhoo,
  fetchStatusMonetary,
  sendEmailExceedPrice,
  getCountrys,
  getMatrixHotels,
  getMealPlanReceiptByVoucherCode,
  getInfoMealPlanPayment
}
